import { useMemo, useState } from 'react';

import ActivitySheet from '../../shared/sheet/activity-sheet';
import SubActivityView from '../../sub-activity/sub-activity-view';
import { ClassroomAnswerInstruction } from 'approot/activity-builder/classroom/classroom-answer.style';
import ClassroomAnswerTabs, {
  QUESTION_VIEW,
  SUGGESTED_VIEW,
} from 'approot/activity-builder/classroom/classroom-answer-tabs';
import { SUGGESTED_ANSWER_VARY } from 'global/constants';
import { useFindComponentDimensions } from '../../component.hooks';
import { COMPONENT_SELECTOR } from '../../shared/logic/get-component-selector-id';
import {
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../../shared/sheet/activity-sheet.style';
import { ViewProps } from '../table.constants';
import { TableWrapper } from '../table-check-answer.style';
import TableViewFields from '../table-view-fields';
import TableResponseSuggestedAnswers from 'approot/activity-builder/classroom/table/table-response-suggested-answers';
import { SampleProps } from '../../sample/activity-sample.constants';

const TableViewSampleAnswerModal = (
  props: ViewProps &
    SampleProps & {
      onClose: () => void;
    }
) => {
  const {
    id,
    type,
    subActivityProperties,
    suggestedAnswerProperties,
    onClose,
    banner,
  } = props;
  const { width } = useFindComponentDimensions(props.id, COMPONENT_SELECTOR);
  const [tab, setTab] = useState<string>(QUESTION_VIEW);

  const showSuggestedAnswers = useMemo(
    () =>
      !!(
        suggestedAnswerProperties?.suggestedAnswerType ===
          SUGGESTED_ANSWER_VARY ||
        (suggestedAnswerProperties?.suggestedAnswers &&
          suggestedAnswerProperties.suggestedAnswers.length > 0)
      ),
    [suggestedAnswerProperties]
  );

  return (
    <ActivitySheet
      isVisible
      title="Table response"
      hasBackgroundColor={tab === QUESTION_VIEW}
      onClose={() => {
        setTab(QUESTION_VIEW);
        onClose();
      }}
      tabsContent={
        <ClassroomAnswerTabs
          isPublished
          canClearModelledResponse={false}
          includeSuggestedAnswers={showSuggestedAnswers}
          includeIndividualAnswers={false}
          includeClassResponse={false}
          tab={tab}
          onSelect={option => setTab(option)}
          componentId={id}
          onCloseActivitySheet={() => {
            setTab(QUESTION_VIEW);
            onClose();
          }}
        />
      }
      banner={banner}
    >
      <ActivitySheetInnerContent id="content">
        {tab === QUESTION_VIEW && (
          <ActivitySheetInnerMax>
            <ClassroomAnswerInstruction>
              <SubActivityView
                withTTSButton
                componentId={id}
                componentType={type}
                subActivityDetails={subActivityProperties}
              >
                <TableWrapper $maxWidth={width}>
                  <TableViewFields
                    {...props}
                    canRespond
                    answers={undefined}
                    updateAnswer={() => {}}
                  />
                </TableWrapper>
              </SubActivityView>
            </ClassroomAnswerInstruction>
          </ActivitySheetInnerMax>
        )}
        {tab === SUGGESTED_VIEW && (
          <ActivitySheetInnerMax>
            <TableResponseSuggestedAnswers component={props} width={width} />
          </ActivitySheetInnerMax>
        )}
      </ActivitySheetInnerContent>
    </ActivitySheet>
  );
};

export default TableViewSampleAnswerModal;
